import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Lock } from "lucide-react";
import logo from "../../images/site_logo/site_logo_3.svg";

import MobileMenu from "../MobileMenu/MobileMenu";

const Header3 = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="site_header site_header_3">
      <div
        className={`header_bottom stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-3 col-lg-2 col-5">
              <div className="site_logo">
                <Link onClick={ClickHandler} className="site_link" to="/">
                  <img
                    src={logo}
                    alt="Site Logo – CA Binod Verma – Chartered Accountant in Delhi"
                  />
                </Link>
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="col-xl-6 col-lg-7 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className="main_menu_inner collapse navbar-collapse justify-content-lg-center"
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list justify-content-center">
                    <li>
                      <Link
                        onClick={ClickHandler}
                        to="/"
                        role="button"
                        aria-expanded="false"
                      >
                        Homepage
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={ClickHandler}
                        to="/about"
                        role="button"
                        aria-expanded="false"
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={ClickHandler}
                        to="/service"
                        role="button"
                        aria-expanded="false"
                      >
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={ClickHandler}
                        to="/blog"
                        role="button"
                        aria-expanded="false"
                      >
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            {/* Right: Admin link (desktop) + Mobile menu button */}
            <div className="col-xl-3 col-lg-3 col-5" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
              {/* Admin button — outside header_btns_group, desktop only */}
              <Link
                to="/admin/login"
                onClick={ClickHandler}
                className="d-none d-lg-inline-flex"
                style={{
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 18px',
                  borderRadius: '10px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#EAEFEF',
                  backgroundColor: '#25343F',
                  textDecoration: 'none',
                  transition: 'opacity 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
              >
                <Lock style={{ width: '13px', height: '13px' }} />
                Admin
              </Link>

              {/* Hamburger — untouched original */}
              <ul className="header_btns_group unordered_list">
                <li>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={handleMobileMenuToggle}
                    className="mobile_menu_btn"
                    sx={{
                      color: "#333",
                      fontSize: "1.5rem",
                      padding: "8px",
                      "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                    }}
                  >
                    <span style={{ fontSize: "24px" }}>☰</span>
                  </IconButton>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <MobileMenu open={mobileMenuOpen} onClose={handleMobileMenuClose} />
    </header>
  );
};

export default Header3;
